import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumReportBuilder implements BaseEnumType {
  private static allValues: EnumReportBuilder[] = []; // make sure this is top-most
  
  public static none = new EnumReportBuilder(0, "None", "enum_report_builder_none");
  public static orders = new EnumReportBuilder(1, "Orders", "enum_report_builder_orders");
  public static orderLines = new EnumReportBuilder(2, "OrderLines", "enum_report_builder_order_lines");
  public static containers = new EnumReportBuilder(3, "Containers", "enum_report_builder_containers");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumReportBuilder.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumReportBuilder.none; }
  public isOrders() { return this === EnumReportBuilder.orders; }
  public isOrderLines() { return this === EnumReportBuilder.orderLines; }
  public isContainers() { return this === EnumReportBuilder.containers; }

  public static getValues(): readonly EnumReportBuilder[] {
    return EnumReportBuilder.allValues;
  }

  public static getValuesExcept0(): readonly EnumReportBuilder[] {
    return EnumReportBuilder.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumReportBuilder {
    const found = EnumReportBuilder.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumReportBuilder - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumReportBuilder): EnumReportBuilder {
    const found = name ? EnumReportBuilder.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumReportBuilder - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumReportBuilder>): boolean {
    return this.key === other?.key;
  }
}